import { NgModule } from '@angular/core';

import { provideConfig } from '@spartacus/core';

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        OrderHistory: {
          cmsComponents: ['AccountOrderHistoryComponent'],
          module: () => import('./order-history').then((m) => m.DpOrderHistoryModule)
        },
        orderDetailsFeature: {
          cmsComponents: [
            'AccountOrderDetailsOverviewComponent',
            'AccountOrderDetailsActionsComponent',
            'AccountOrderDetailsItemsComponent',
            'AccountOrderDetailsTotalsComponent'
          ],
          module: () => import('./order-details').then((m) => m.DpOrderDetailsModule)
        },
        orderOverviewFeature: {
          cmsComponents: [
            'OrderConfirmationOverviewComponent',
            'OrderConfirmationThankMessageComponent',
            'ReplenishmentConfirmationMessageComponent',
            'OrderConfirmationFeedbackComponent'
          ],
          module: () => import('./order-confirmation').then((m) => m.DpOrderConfirmationModule)
        }
      }
    })
  ]
})
export class DpOrderFeatureModule {}
